/* eslint-disable no-use-before-define */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { humanize, titleize, unescapeHTML } from 'underscore.string';
import { withTranslation, Translation } from 'react-i18next';
import { DropdownButton, MenuItem, Badge, Pagination } from 'react-bootstrap';
import _ from 'underscore';
import { cloneDeep } from 'lodash';

import CargomaticCard from 'components/v2/card';
import CargomaticBadge from 'components/v2/Badge';
import AddButton from 'components/v2/buttons/AddButton';
import { massUpdateActions } from 'constants/MassUpdates';
import OrdersActionCreators from 'actions/OrdersActionCreators';
import ShipmentsActionCreators from 'actions/ShipmentsActionCreators';
import EquipmentActionCreators from 'actions/EquipmentActionCreators';
import OrderShipmentsStore from 'stores/OrderShipmentsStore';
import { updateOrder } from 'utils/OrderWebAPIUtils';

import EditEquipmentModal from 'components/modules/equipment/EditEquipmentModal';
import SendDOEmailModal from 'components/modules/shipments/SendDOEmailModal';
import BulkEditModal from 'components/modules/shipments/MassUpdateModal';
import BulkUpdateSendDOModal from 'components/modules/shipments/BulkUpdateSendDOModal';
import BulkUpdateCarrierCostModal from 'components/modules/shipments/BulkUpdateCarrierCostModal';
import ChangeUserModal from 'components/modules/shipments/ChangeUserModal';
import SessionStore from 'stores/SessionStore';
import TripFormStore from 'stores/TripFormStore';
import { sluggify } from 'utils/localization/utils';
import { Disclosure } from '@headlessui/react';
import { createShipment } from './CreateShipment';
import ManageStagingItem from './ManageStagingItem';
import RemoveShipmentModal from './RemoveShipmentModal';
import { isIntermodalShipmentType } from '../../../helpers/shipment-types';
import TripPlannerModal from '../shipments/TripPlannerModal';
import GenerateTripModal from '../shipments/trips/GenerateTripModal';
import { getDeliveryOrderRecipients } from '../../../helpers/shipments';
import BulkBookingForm from '../booking/BulkBookingForm';
import { getDocuments, getSignedUrl } from '../../../utils/DocumentsAPIUtils';
import { showToast } from '../../../stores/ToastStore';
import ConfirmAssignCarrierModal from '../shipments/ConfirmAssignCarrierModal';

const mapStagingShipmentItem = (shipment) => ({
  ...shipment,
  deliveryOrderGenerating: false,
  editRow: false,
  expanded: false,
});

const mapShipmentItem = (shipment) => ({
  ...shipment,
  deliveryOrderGenerating: false,
  editRow: false,
  expanded: false,
});

class ShipmentsList extends Component {
  static propTypes = {
    order: PropTypes.object,
    renderedInModal: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      accountingHold: false,
      showSendEmailModal: false,
      showTripPlannerModal: false,
      showGenerateTripModal: false,
      showBulkBookingFormModal: false,
      showRemoveModal: false,
      showEditEquipmentModal: false,
      selectedShipment: null,
      selectedEquipment: null,
      bookedShipmentsLoaded: false,
      stagingShipmentsLoaded: false,
      expanded: [],
      selected: [],
      selectAll: false,
      stagingShipments: props.stagingShipments,
      shipments: [],
      bookedShipments: props.bookedShipments,
      disableCreateShipment: false,
      paginationData: props.paginationData,
    };
  }

  componentDidMount() {
    OrderShipmentsStore.addShipmentCreationListener(
      this.handleOrderShipmentCreation,
    );
    TripFormStore.addTripAppliedEventListener(this.handleTripAppliedEvent);

    this.handleOrderShipmentsStoreChange();
    this.handleStagingShipmentsChange();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const accountingHold =
      nextProps.order.shipper && nextProps.order.shipper.accounting
        ? nextProps.order.shipper.accounting.on_hold
        : false;
    this.setState({ accountingHold });
    if (this.props.order._id !== nextProps.order._id) {
      this.props.onGetPaginatedShipments(1);
      this.handleStagingShipmentsChange(nextProps.stagingShipments);
    }

    if (this.props.bookedShipments !== nextProps.bookedShipments) {
      this.updateShipmentsState(nextProps.bookedShipments);
    }

    if (this.props.stagingShipments !== nextProps.stagingShipments) {
      this.handleStagingShipmentsChange(nextProps.stagingShipments);
    }

    if (this.props.paginationData !== nextProps.paginationData) {
      this.setState({ paginationData: nextProps.paginationData });
    }
  }

  componentWillUnmount() {
    OrderShipmentsStore.removeShipmentCreationListener(
      this.handleOrderShipmentCreation,
    );
    TripFormStore.removeTripAppliedEventListener(this.handleTripAppliedEvent);
  }

  getSelectedShipments = () => {
    const { selected } = this.state;

    return this.state.shipments.filter((s) => selected.includes(s._id));
  };

  handleShowBulkBookingForm = () =>
    this.setState({ showBulkBookingFormModal: true });

  handleHideBulkBookingForm = () =>
    this.setState({ showBulkBookingFormModal: false });

  handleBulkBookingSuccess = () => {
    setTimeout(() => {
      this.handleHideBulkBookingForm();
    }, 2000);
    this.props.onGetPaginatedShipments(1);
  };

  handleTripAppliedEvent = () => {
    const context = TripFormStore.getTripContext();
    const {
      formStatus: { completed, success },
    } = context;

    if (completed && success) {
      this.props.onGetPaginatedShipments(1);
    }
  };

  handleStagingShipmentsChange = (stagingShipments = []) => {
    this.updateStagingShipmentsState(
      stagingShipments.map(mapStagingShipmentItem),
    );
  };

  updateStagingShipmentsState = (nextStagingShipments) => {
    this.setState((prevState) => {
      const stagingShipments = nextStagingShipments.reduce(
        (runningList, stagedShipment) => {
          const isExpanded = prevState.expanded.includes(stagedShipment._id);
          if (isExpanded) {
            const expandedRow = cloneDeep(stagedShipment);
            expandedRow.editRow = true;
            expandedRow.expanded = true;
            return runningList.concat([stagedShipment, expandedRow]);
          }
          return runningList.concat(stagedShipment);
        },
        [],
      );

      const shipments = [...stagingShipments, ...prevState.bookedShipments];

      const updatedShipmentListState = getShipmentListState(
        shipments,
        prevState,
      );

      const stagingShipmentsLoaded = true;

      return {
        stagingShipments,
        shipments,
        ...updatedShipmentListState,
        stagingShipmentsLoaded,
      };
    });
  };

  generateTripDisabled() {
    return this.state.selected.length === 0;
  }

  handleOrderShipmentsStoreChange = () => {
    const { bookedShipments } = this.state;
    this.updateShipmentsState(bookedShipments.map(mapShipmentItem));
  };

  handleOrderShipmentCreation = (type) => {
    // Can't create a shipment while a request is in progress. When it's done the type will be 'SUCCEEDED' or 'FAILED'.
    const disableCreateShipment = type === 'REQUESTED';
    this.setState({ disableCreateShipment });
  };

  handleRemoveShipment = (selectedShipment) =>
    this.setState({
      showRemoveModal: true,
      selectedShipment,
    });

  closeEquipmentModal = () => {
    this.setState({
      showEditEquipmentModal: false,
      selectedEquipment: null,
    });
  };

  isShipmentExpanded = (id) => this.state.expanded.includes(id);

  isShipmentSelected = (id) => this.state.selected.includes(id);

  handleEditEquipment = (selectedEquipment) =>
    this.setState({
      showEditEquipmentModal: true,
      selectedEquipment,
    });

  handleSelectAllChange = (e) => {
    const {
      target: { checked: selectAll },
    } = e;

    this.setState((prevState) => {
      const { shipments } = prevState;

      let selected = [];
      if (selectAll) {
        selected = shipments.map((s) => s._id);
      }
      return {
        selected,
        selectAll,
      };
    });
  };

  handleSelectRowChange = (_id, checked) => {
    this.setState((prevState) => {
      const { shipments, selected: currentSelected } = prevState;

      let selected;
      if (checked) {
        selected = [...currentSelected, _id];
      } else {
        const index = currentSelected.findIndex((s) => s === _id);
        selected = [
          ...currentSelected.slice(0, index),
          ...currentSelected.slice(index + 1),
        ];
      }

      const selectAll = selected.length === shipments.length;
      return {
        selectAll,
        selected,
      };
    });
  };

  handleToggleExpand = (id, toggled) => {
    this.setState((prevState) => {
      const { shipments: currentShipments, expanded: currentExpanded } =
        prevState;

      let expanded;
      const shipmentIndex = currentShipments.findIndex(
        (s) => s._id === id && !s.editRow,
      );
      const summaryRow = currentShipments[shipmentIndex];

      let editRow;

      const editRowIndex = currentShipments.findIndex(
        (s) => s._id === id && s.editRow,
      );
      let shipments;
      if (editRowIndex !== -1) {
        editRow = cloneDeep(currentShipments[editRowIndex]);
        shipments = [
          ...currentShipments.slice(0, shipmentIndex),
          summaryRow,
          editRow,
          ...currentShipments.slice(shipmentIndex + 2),
        ];
      } else {
        editRow = cloneDeep(summaryRow);
        shipments = [
          ...currentShipments.slice(0, shipmentIndex),
          summaryRow,
          editRow,
          ...currentShipments.slice(shipmentIndex + 1),
        ];
      }
      editRow.editRow = true;

      if (toggled) {
        expanded = [...currentExpanded, id];

        editRow.expanded = true;
      } else {
        editRow.expanded = false;
        expanded = [
          ...currentExpanded.slice(0, shipmentIndex),
          ...currentExpanded.slice(shipmentIndex + 1),
        ];
      }

      return {
        expanded,
        shipments,
      };
    });
  };

  handleSaveEquipment = (equipment) => {
    EquipmentActionCreators.updateEquipment(equipment);

    // For Staging shipments, equipments are on the stop level. Stops in the stops array of
    // ShipmentStagingSchema aren't mapped to Mongo ids, so they don't get re-populated
    // when changes are made to an individual equipment item. The following obviously isn't
    // ideal, but with the current architecture it's the only way to make sure that equipments
    // attached to a stop in Shipment Staging get updated when their properties change.
    // We need to go through all the Staging shipments because the same piece of equipment
    // can be on multiple ones.

    if (!_.isEmpty(this.props.order.shipments_staging)) {
      const stagingShipmentsToUpdate = this.props.order.shipments_staging.map(
        (shipment) => {
          shipment.stops = shipment.stops.map((stop) => {
            stop.equipments = stop.equipments.map((eq) => {
              if (eq._id === equipment._id) {
                return equipment;
              }
              return eq;
            });
            return stop;
          });
          return shipment;
        },
      );

      updateOrder(this.props.order._id, {
        shipments_staging: stagingShipmentsToUpdate,
      });
    }
  };

  handleCloseGenerateTripModal = () => {
    this.setState({
      selected: [],
      selectAll: false,
      showGenerateTripModal: false,
    });
  };

  handleShowGenerateTripModal = () => {
    this.setState({ showGenerateTripModal: true });
  };

  handleShowTripPlannerModal = () => {
    this.setState({ showTripPlannerModal: true });
  };

  handleCloseTripPlannerModal = () => {
    this.setState({ showTripPlannerModal: false });
  };

  onHideBulkEditModal = () => this.setState({ showBulkEditModal: false });

  getDeliveryOrderRecipient = () => {
    const recipient = '';

    if (this.state.selectedShipment) {
      const shipment = this.state.shipments.filter(
        (s) => s._id === this.state.selectedShipment,
      );

      if (shipment.length) {
        return getDeliveryOrderRecipients(shipment[0].carrier);
      }
    }

    return recipient;
  };

  handleSendDeliveryOrder = (selectedShipment) =>
    this.setState({ showSendEmailModal: true, selectedShipment });

  handleGenerateDeliveryOrder = (jobId) => {
    this.setState(
      (currentState) => {
        const { shipments: currentShipments } = currentState;

        const index = currentShipments.findIndex((j) => j._id === jobId);
        if (index === -1) {
          return null;
        }
        const shipment = cloneDeep(currentShipments[index]);
        shipment.generateDeliveryOrder = true;

        const shipments = [
          ...currentShipments.slice(0, index),
          shipment,
          ...currentShipments.slice(index + 1),
        ];

        return {
          shipments,
        };
      },
      () => OrdersActionCreators.generateDeliveryOrder(jobId),
    );
  };

  handleBulkActionMenu = (bulkAction) => {
    switch (bulkAction) {
      case massUpdateActions.CHANGE_CARRIER:
        this.setState({
          bulkAction,
          showChangeCarrierModal: true,
        });
        break;
      case massUpdateActions.SEND_DELIVERY_ORDER:
        this.setState({
          bulkAction,
          showBulkUpdateSendDoModal: true,
        });
        break;
      case massUpdateActions.UPDATE_CARRIER_COST:
        this.setState({
          bulkAction,
          showBulkUpdateCarrierCostModal: true,
        });
        break;
      default:
        this.setState({
          bulkAction,
          showBulkEditModal: true,
        });
        break;
    }
  };

  updateShipmentsState(bookedShipments) {
    this.setState((prevState) => {
      const { stagingShipments } = prevState;

      const shipments = [...stagingShipments, ...bookedShipments];

      const updatedShipmentListState = getShipmentListState(
        shipments,
        prevState,
      );
      const bookedShipmentsLoaded = true;

      return {
        ...updatedShipmentListState,
        bookedShipments,
        bookedShipmentsLoaded,
        shipments,
      };
    });
  }

  sendEmail() {
    return (emails) => {
      ShipmentsActionCreators.sendDeliveryOrder(
        this.state.selectedShipment,
        emails,
      );
    };
  }

  renderBulkActionMenu() {
    const { t } = this.props;
    return (
      <DropdownButton
        id="bulk-actions-dropdown"
        className="mb-4 sm:mb-0"
        disabled={!this.state.selected.length || this.props.renderedInModal}
        title={t('BULK_ACTIONS')}
        onSelect={this.handleBulkActionMenu}
        bsStyle="danger"
      >
        <MenuItem eventKey={massUpdateActions.UPDATE_APPOINTMENT_WINDOW}>
          {t('UPDATE_APPOINTMENT_WINDOW')}
        </MenuItem>
        <MenuItem eventKey={massUpdateActions.EDIT_DISCHARGE}>
          {t('UPDATE_DISCHARGE')}
        </MenuItem>
        <MenuItem eventKey={massUpdateActions.EDIT_LAST_FREE_DAY}>
          {t('UPDATE_LFD')}
        </MenuItem>
        <MenuItem eventKey={massUpdateActions.CHANGE_CARRIER}>
          {t('ASSIGN_CARRIER')}
        </MenuItem>
        <MenuItem eventKey={massUpdateActions.UPDATE_CARRIER_COST}>
          {titleize(t('UPDATE_CARRIER_COST'))}
        </MenuItem>
        <MenuItem eventKey={massUpdateActions.SEND_DELIVERY_ORDER}>
          {t('SEND_DO')}
        </MenuItem>
      </DropdownButton>
    );
  }

  renderHeaderRow() {
    const { t } = this.props;
    return (
      <tr className="border-b border-solid border-grey bg-grey-lightest">
        <th className="p-4">
          <input
            type="checkbox"
            checked={this.state.selectAll}
            onChange={this.handleSelectAllChange}
          />
        </th>
        <th className="p-4 text-sm font-bold text-grey-darker">{t('ID')}</th>
        <th
          className="p-4 text-sm font-bold text-grey-darker"
          style={{ width: '120px' }}
        >
          {t('STATUS')}
        </th>
        <th
          className="p-4 text-sm font-bold text-grey-darker"
          style={{ width: '210px' }}
        >
          {t('BILLING_STATUS')}
        </th>
        <th className="p-4 text-sm font-bold text-grey-darker">
          {t('EQUIPMENT_ID')}
        </th>
        <th
          className="p-4 text-sm font-bold text-grey-darker"
          style={{ width: '200px' }}
        >
          {titleize(t('PICKUP'))}
        </th>
        <th
          className="p-4 text-sm font-bold text-grey-darker"
          style={{ width: '200px' }}
        >
          {titleize(t('DELIVER'))}
        </th>
        <th className="p-4 text-sm font-bold text-grey-darker">
          {titleize(t('CARRIER'))}
        </th>
        <th className="p-4 text-sm font-bold text-grey-darker">
          {t('DELIVERY_ORDER')}
        </th>
        <th className="p-4 text-sm font-bold text-grey-darker">&nbsp;</th>
      </tr>
    );
  }

  renderShipments() {
    const { bookedShipmentsLoaded, stagingShipmentsLoaded, shipments } =
      this.state;
    const { t } = this.props;
    if (!bookedShipmentsLoaded && !stagingShipmentsLoaded) {
      return (
        <tr>
          <td colSpan="6" className="p-2">
            <i className="mr-2 fa fa-spin fa-circle-o-notch" />
            {t('LOADING_SHIPMENTS')}...
          </td>
        </tr>
      );
    }

    if (shipments.length === 0) {
      return (
        <tr>
          <td colSpan="6" className="p-2">
            <h4 className="text-base text-grey-dark">
              {t('NO_SHIPMENTS_CLICK_TO_ADD_MORE')}
            </h4>
          </td>
        </tr>
      );
    }

    return this.state.shipments.map((shipment) => (
      <OrderShipment
        order={this.props.order}
        shipment={shipment}
        selected={this.isShipmentSelected(shipment._id)}
        expanded={this.isShipmentExpanded(shipment._id)}
        onSelectRowChange={this.handleSelectRowChange}
        onEditEquipment={this.handleEditEquipment}
        onGenerateDeliveryOrder={this.handleGenerateDeliveryOrder}
        onSendDeliveryOrder={this.handleSendDeliveryOrder}
        onRemoveShipment={this.handleRemoveShipment}
        onToggleExpand={this.handleToggleExpand}
        key={getKey(shipment)}
      />
    ));
  }

  renderTripPlannerButtons = () => {
    if (!SessionStore.hasTripPlannerRole()) {
      return [];
    }
    const { t } = this.props;
    return [
      <button
        key="create-trip-button"
        type="button"
        className="mb-4 rounded-full sm:mb-0 button button-hollow-green"
        onClick={this.handleShowTripPlannerModal}
      >
        {t('PLAN_A_TRIP')}
      </button>,
      <button
        key="generate-trip-button"
        type="button"
        className="mb-4 rounded-full sm:mb-0 button button-hollow-green"
        disabled={this.generateTripDisabled()}
        onClick={this.handleShowGenerateTripModal}
      >
        {t('GENERATE_A_TRIP')}
      </button>,
    ];
  };

  renderBulkBookingButton() {
    const { t } = this.props;

    const button = (
      <button
        className="mb-4 rounded-full sm:mb-0 button button-hollow-green"
        onClick={this.handleShowBulkBookingForm}
      >
        {t('BOOK_MULTIPLE_SHIPMENTS')}
      </button>
    );

    return [button];
  }

  renderBulkActionsButton = () => {
    return [this.renderBulkActionMenu()];
  };

  renderShipmentActions = () => {
    return [
      ...this.renderTripPlannerButtons(),
      ...this.renderBulkBookingButton(),
      ...this.renderBulkActionsButton(),
    ];
  };

  onPaginationSelect = (eventKey) =>
    this.props.onGetPaginatedShipments(eventKey);

  renderPagination() {
    const { paginationData } = this.state;
    const items = (paginationData && paginationData.totalPages) || 1;
    const activePage = (paginationData && paginationData.currentPage) || 1;
    return (
      <Pagination
        prev
        next
        first
        last
        ellipsis
        items={items}
        maxButtons={5}
        activePage={activePage}
        onSelect={this.onPaginationSelect}
      />
    );
  }

  render() {
    const {
      order: { _id: orderId, carrier: orderCarrier },
      t,
    } = this.props;
    const shipperId =
      this.props.order?.shipper?._id || this.props.order?.shipper?.id;
    const defaultDeliveryOrderRecipient = this.getDeliveryOrderRecipient();
    const carrierAuthorized = orderCarrier && orderCarrier.authorized;
    const carrier = carrierAuthorized ? orderCarrier : null;
    return (
      <CargomaticCard
        removeHorizontalPadding
        removeVerticalPadding
        header={() => (
          <div className="flex flex-wrap justify-between">
            <div className="flex items-center mb-4 sm:mb-0 space-x-2">
              <div className="flex items-center">
                <h3 className="my-0">
                  {titleize(t('SHIPMENT', { count: 2 }))}
                </h3>
                {this.state.accountingHold && (
                  <CargomaticBadge color="red" className="ml-1">
                    {t('ACCOUNT_ON_HOLD')}
                  </CargomaticBadge>
                )}
              </div>
              <AddButton
                id="order-add-shipment-button"
                className="shipment-shipmentsList-addShipmentForDrayage heap"
                onClick={() => {
                  createShipment(this.props, {
                    shipment_type: 'drayage',
                    no_equipment: true,
                  });
                }}
                disabled={
                  this.state.accountingHold || this.state.disableCreateShipment
                }
              />
            </div>
            <div className="flex flex-wrap items-start space-x-2">
              {this.renderShipmentActions()}
            </div>
          </div>
        )}
      >
        {this.state.showGenerateTripModal && (
          <GenerateTripModal
            show={this.state.showGenerateTripModal}
            onClose={this.handleCloseGenerateTripModal}
            onGenerateTrip={this.handleGenerateTrip}
            orderId={this.props.order._id}
            shipments={this.getSelectedShipments()}
          />
        )}
        {this.state.showTripPlannerModal && (
          <TripPlannerModal
            show={this.state.showTripPlannerModal}
            onClose={this.handleCloseTripPlannerModal}
            shipperId={shipperId}
            orderId={this.props.order._id}
            carrier={carrier}
            equipments={this.props.order.equipments}
          />
        )}
        {this.state.showRemoveModal && (
          <RemoveShipmentModal
            show={this.state.showRemoveModal}
            onClose={() => {
              this.setState({
                showRemoveModal: false,
                selectedShipment: null,
              });
            }}
            order={this.props.order}
            _id={this.state.selectedShipment}
          />
        )}
        {this.state.showEditEquipmentModal && (
          <EditEquipmentModal
            show={this.state.showEditEquipmentModal}
            onHide={this.closeEquipmentModal}
            equipment={this.state.selectedEquipment}
            onSave={this.handleSaveEquipment}
          />
        )}
        {this.state.showBulkEditModal && (
          <BulkEditModal
            show
            action={this.state.bulkAction}
            onHide={this.onHideBulkEditModal}
            shipments={this.state.selected}
            origin={this.props.order.arriving[0]}
            destination={this.props.order.delivering[0]}
          />
        )}
        {this.state.showChangeCarrierModal && (
          <ChangeUserModal
            jobs={this.getSelectedShipments()}
            show={this.state.showChangeCarrierModal}
            type="carrier"
            onSave={ShipmentsActionCreators.updateCarrier}
            onAssignBrokerCarrier={(shipment, driver) =>
              this.setState({
                showConfirmAssignCarrierModal: true,
                showChangeCarrierModal: false,
                brokerCarrierDriver: driver,
              })
            }
            onHide={() => this.setState({ showChangeCarrierModal: false })}
          />
        )}
        <ConfirmAssignCarrierModal
          isOpen={this.state.showConfirmAssignCarrierModal}
          brokerCarrierDriver={this.state.brokerCarrierDriver}
          shipment={this.getSelectedShipments()}
          onConfirm={(shipments, carrier) => {
            ShipmentsActionCreators.updateCarrier(carrier, shipments);
          }}
          onClose={() =>
            this.setState({ showConfirmAssignCarrierModal: false })
          }
        />
        {this.state.showBulkUpdateCarrierCostModal && (
          <BulkUpdateCarrierCostModal
            title={t('UPDATE_CARRIER_COSTS')}
            show={this.state.showBulkUpdateCarrierCostModal}
            shipments={this.state.selected}
            onHide={() => {
              this.setState({ showBulkUpdateCarrierCostModal: false });
            }}
          />
        )}
        {this.state.showBulkUpdateSendDoModal && (
          <BulkUpdateSendDOModal
            title={titleize(t('SEND_DELIVERY_ORDER'))}
            send_do={
              this.state.bulkAction === massUpdateActions.SEND_DELIVERY_ORDER
            }
            show={this.state.showBulkUpdateSendDoModal}
            shipments={this.state.selected}
            onHide={() => this.setState({ showBulkUpdateSendDoModal: false })}
          />
        )}
        <div className="">
          <table className="w-full mb-6 border-collapse">
            <thead>{this.renderHeaderRow()}</thead>
            <tbody>{this.renderShipments()}</tbody>
          </table>
          <div className="flex flex-row-reverse pr-6">
            {this.renderPagination()}
          </div>
        </div>
        {this.state.showSendEmailModal && (
          <SendDOEmailModal
            show={this.state.showSendEmailModal}
            onSend={this.sendEmail()}
            onHide={() => this.setState({ showSendEmailModal: false })}
            defaultRecipient={defaultDeliveryOrderRecipient}
          />
        )}
        {this.state.showBulkBookingFormModal && (
          <BulkBookingForm
            orderId={this.props.order._id}
            order={this.props.order}
            show={this.state.showBulkBookingFormModal}
            onHide={this.handleHideBulkBookingForm}
            onSaveSuccess={this.handleBulkBookingSuccess}
            origin={this.props.order.arriving[0]}
            destination={this.props.order.delivering[0]}
            shipperId={shipperId}
          />
        )}
      </CargomaticCard>
    );
  }
}

class OrderShipment extends Component {
  static propTypes = {
    onEditEquipment: PropTypes.func.isRequired,
    onGenerateDeliveryOrder: PropTypes.func.isRequired,
    onSendDeliveryOrder: PropTypes.func.isRequired,
    onRemoveShipment: PropTypes.func.isRequired,
    onSelectRowChange: PropTypes.func.isRequired,
    onToggleExpand: PropTypes.func.isRequired,
    selected: PropTypes.bool,
    order: PropTypes.object.isRequired,
    shipment: PropTypes.shape({
      isStaging: PropTypes.bool.isRequired,
      _id: PropTypes.string.isRequired,
    }).isRequired,
    expanded: PropTypes.bool,
  };

  static defaultProps = {
    selected: false,
    expanded: false,
  };

  handleGenerateDeliveryOrder = (shipmentId) =>
    this.props.onGenerateDeliveryOrder(shipmentId);

  handleSendDeliveryOrder = (shipmentId) =>
    this.props.onSendDeliveryOrder(shipmentId);

  handleToggleExpand = () =>
    this.props.onToggleExpand(this.props.shipment._id, !this.props.expanded);

  handleRemoveShipment = () =>
    this.props.onRemoveShipment(this.props.shipment._id);

  handleEditEquipment = (equipmentId) => {
    const {
      shipment: { equipments },
    } = this.props;

    const equipment = equipments.find((eq) => eq._id === equipmentId);
    this.props.onEditEquipment(equipment);
  };

  handleCheckboxChange = (e) => {
    const {
      target: { checked },
    } = e;
    const {
      shipment: { _id },
    } = this.props;

    this.props.onSelectRowChange(_id, checked);
  };

  handleCancelEdit = () =>
    this.props.onToggleExpand(this.props.shipment._id, false);

  renderActions() {
    const { shipment } = this.props;

    const { isStaging } = shipment;

    if (isStaging) {
      return (
        <StagingActions
          onRemoveShipment={this.handleRemoveShipment}
          onToggleExpand={this.handleToggleExpand}
        />
      );
    }

    return (
      <ManageButton
        shipment={shipment}
        onGenerateDeliveryOrder={this.handleGenerateDeliveryOrder}
        onSendDeliveryOrder={this.handleSendDeliveryOrder}
      />
    );
  }

  renderRow() {
    const { selected, shipment } = this.props;

    const { status, billing_status } = shipment;

    return (
      <Disclosure as="tr">
        <td className="p-4">
          <input
            type="checkbox"
            checked={selected}
            onChange={this.handleCheckboxChange}
          />
        </td>
        <td className="p-4">{formatId(shipment)}</td>
        <td className="p-4">{formatStatus(status)}</td>
        <td className="p-4">{formatBillingStatus(billing_status)}</td>
        <td className="p-4">
          <EquipmentsColumn
            equipments={shipment.equipments}
            onEditEquipment={this.handleEditEquipment}
          />
        </td>
        <td className="p-4">{formatLocation(shipment.pickup)}</td>
        <td className="p-4">{formatLocation(shipment.deliver)}</td>
        <td className="p-4">{formatCarrier(shipment)}</td>
        <td className="p-4">
          <DeliveryOrderColumnWithLocalization shipment={shipment} />
        </td>
        <td className="p-4">{this.renderActions()}</td>
      </Disclosure>
    );
  }

  renderExpandedRow() {
    const { order, shipment } = this.props;

    return (
      <tr>
        <td colSpan="10">
          <ManageStagingItem
            order={order}
            shipment={shipment}
            cancelEditing={this.handleCancelEdit}
          />
        </td>
      </tr>
    );
  }

  render() {
    const {
      shipment: { editRow },
      expanded,
    } = this.props;

    if (editRow) {
      return expanded ? this.renderExpandedRow() : null;
    }

    return this.renderRow();
  }
}

function getKey(shipment) {
  const { isStaging, _id, editRow } = shipment;

  const rowTypeLabel = editRow ? 'expanded' : 'summary';
  return `shipment-${_id}-${isStaging}-${rowTypeLabel}`;
}

function formatId(shipment) {
  const { isStaging, shipment_id } = shipment;

  if (isStaging) {
    return null;
  }

  const link = `/shipments/${shipment._id}`;
  return (
    <a href={link} target="_blank" rel="noopener noreferrer">
      {shipment_id}
    </a>
  );
}

function formatCarrier(shipment) {
  const { carrier } = shipment;
  if (!carrier) {
    return null;
  }
  const carrierId = carrier._id ? carrier._id : carrier;
  const link = `/users/${carrierId}`;
  return (
    <a href={link} target="_blank" rel="noopener noreferrer">
      {unescapeHTML(carrier.name)}
    </a>
  );
}

const colors = {
  available: 'bg-green',
  unavailable: 'bg-red-500',
  'In Progress': 'bg-teal-400',
  accepted: 'bg-green',
  'Awaiting Booking': 'bg-purple-500',
};

function formatStatus(cell) {
  const bg = colors[cell] || 'bg-green';

  const classNames = classnames({
    'p-1': true,
    rounded: true,
    [bg]: true,
    'text-white': true,
    'text-sm': true,
    'font-bold': true,
  });
  return (
    <Translation>
      {(t, { i18n }) => <span className={classNames}>{t(sluggify(cell))}</span>}
    </Translation>
  );
}

function formatBillingStatus(cell) {
  const bg = 'bg-green';

  const classNames = classnames({
    'p-2': true,
    rounded: true,
    [bg]: true,
    'text-white': true,
    'text-sm': true,
    'font-bold': true,
  });

  return (
    <Translation>
      {(t, { i18n }) => <span className={classNames}>{titleize(t(sluggify(cell)))}</span>}
    </Translation>
  );
}

function formatLocation(cell) {
  if (!cell) {
    return null;
  }

  return (
    <div>
      <div>
        {cell.name && (
          <label className="mr-2 text-sm font-bold text-grey-darker">
            {unescapeHTML(cell.name)}
          </label>
        )}
      </div>
      <span className="mb-4">{cell.address}</span>
    </div>
  );
}

class DeliveryOrderColumn extends Component {
  static propTypes = {
    shipment: PropTypes.object.isRequired,
  };

  openDeliveryOrder = (shipment) => async (event) => {
    const { t } = this.props;
    event.preventDefault();
    const { data, errors: documentErrors } = await getDocuments(
      [shipment._id],
      'delivery_order',
      {
        order: {
          field: 'createdAt',
          direction: 'desc',
        },
        limit: 1,
      },
    );

    if (documentErrors) {
      showToast(
        t('GET_DOCUMENT_ERROR'),
        t('GET_DOCUMENT_FAILED_WITH_ERROR', {
          error: documentErrors[0].message,
        }),
        'error',
      );
      return;
    }

    if (data?.getDocuments?.documents?.length > 0) {
      const { data: signedUrl, errors: signedUrlErrors } = await getSignedUrl(
        data.getDocuments.documents[0].key,
      );

      if (signedUrlErrors) {
        showToast(
          t('GET_SIGNED_URL_ERROR'),
          t('GET_SIGNED_URL_FAILED_WITH_ERROR', {
            error: signedUrlErrors[0].message,
          }),
          'error',
        );
        return;
      }

      if (signedUrl?.getSignedUrl?.signedUrl) {
        const delivery_order_signed_link = signedUrl.getSignedUrl.signedUrl;
        window.open(delivery_order_signed_link, 'new');
      }
    }
  };

  render() {
    const { shipment } = this.props;
    const { generateDeliveryOrder, delivery_order_sent, carrier } = shipment;

    if (!carrier) {
      return null;
    }

    const badgeStyle = {
      position: 'absolute',
      top: '-5px',
      right: '-20px',
      background: 'red',
      fontSize: '9px',
    };

    return (
      <Translation>
        {(t, { i18n }) => (
          <div>
            {generateDeliveryOrder && (
              <button disabled className="button">
                <div className="flex items-center">
                  <i className="mr-2 fa fa-circle-o-notch fa-spin" />
                  <span>{titleize(t('UPDATING'))}...</span>
                </div>
              </button>
            )}

            {!generateDeliveryOrder && (
              <div>
                <a
                  href="#"
                  title="Delivery Order"
                  className="relative items-start button button-green"
                  onClick={this.openDeliveryOrder(shipment)}
                >
                  <span>{titleize(t('DOWNLOAD'))}</span>
                  {delivery_order_sent && (
                    <Badge style={badgeStyle}>{t('SENT')}</Badge>
                  )}
                </a>
              </div>
            )}
          </div>
        )}
      </Translation>
    );
  }
}

const DeliveryOrderColumnWithLocalization =
  withTranslation()(DeliveryOrderColumn);

class EquipmentsColumn extends Component {
  static propTypes = {
    equipments: PropTypes.arrayOf(
      PropTypes.shape({
        _id: PropTypes.string,
        equipment_id: PropTypes.string,
      }),
    ),
    onEditEquipment: PropTypes.func.isRequired,
  };

  static defaultProps = {
    equipments: [],
  };

  handleClick = (equipmentId) => (e) => {
    e.preventDefault();
    this.props.onEditEquipment(equipmentId);
  };

  render() {
    const { equipments } = this.props;

    if (!equipments || equipments.length === 0) {
      return null;
    }
    return (
      <div>
        {equipments.map((equipment) => (
          <a
            key={equipment._id}
            href="#"
            className="block mb-2"
            onClick={this.handleClick(equipment._id)}
          >
            {equipment.equipment_id}
          </a>
        ))}
      </div>
    );
  }
}

class ManageButton extends Component {
  static propTypes = {
    shipment: PropTypes.shape({
      _id: PropTypes.string,
    }),
    onGenerateDeliveryOrder: PropTypes.func.isRequired,
    onSendDeliveryOrder: PropTypes.func.isRequired,
  };

  handleSelect = (key) => {
    const {
      shipment: { _id },
    } = this.props;
    if (key === 'view') {
      const link = `/shipments/${_id}`;
      window.open(link, '_blank');
    } else if (key === 'generate-delivery-order') {
      this.props.onGenerateDeliveryOrder(_id);
    } else if (key === 'email-delivery-order') {
      this.props.onSendDeliveryOrder(_id);
    }
  };

  render() {
    const { shipment } = this.props;

    const { _id, carrier } = shipment;

    const buttonId = `manage-shipment-${_id}`;

    return (
      <Translation>
        {(t, { i18n }) => (
          <DropdownButton
            id={buttonId}
            title={t('MANAGE')}
            style={{
              backgroundColor: 'white',
              color: '#25AA82',
              borderColor: '#25AA82',
              fontSize: '.875rem',
              fontWeight: '700',
              borderRadius: '.25rem',
            }}
            onSelect={this.handleSelect}
          >
            {carrier && isIntermodalShipmentType(shipment) && (
              <MenuItem
                eventKey="email-delivery-order"
                style={{ fontSize: '.875rem' }}
              >
                {t('EMAIL_DELIVERY_ORDER')}
              </MenuItem>
            )}
            {carrier && (
              <MenuItem
                eventKey="generate-delivery-order"
                style={{ fontSize: '.875rem' }}
              >
                {t('GENERATE_DELIVERY_ORDER')}
              </MenuItem>
            )}
            <MenuItem eventKey="view" style={{ fontSize: '.875rem' }}>
              {t('VIEW_DETAILS')}
            </MenuItem>
          </DropdownButton>
        )}
      </Translation>
    );
  }
}

class StagingActions extends Component {
  static propTypes = {
    onRemoveShipment: PropTypes.func.isRequired,
    onToggleExpand: PropTypes.func.isRequired,
  };

  handleToggleExpand = () => this.props.onToggleExpand();

  handleRemoveShipment = () => this.props.onRemoveShipment();

  render() {
    return (
      <Translation>
        {(t, { i18n }) => (
          <div className="flex flex-row">
            <Disclosure.Button
              className="mr-2 text-white button bg-blue-cm hover:bg-blue-cm-darker"
              onClick={this.handleToggleExpand}
            >
              {titleize(t('EDIT'))}
            </Disclosure.Button>

            <button
              className="text-white button bg-grey-dark hover:bg-grey-darker"
              onClick={this.handleRemoveShipment}
            >
              <i className="fa fa-trash-o" />
            </button>
          </div>
        )}
      </Translation>
    );
  }
}

function getShipmentListState(shipments, prevState) {
  const shipmentIds = shipments.map((s) => s._id);
  const selected = prevState.selected.filter((id) => shipmentIds.includes(id));
  const expanded = prevState.expanded.filter((id) => shipmentIds.includes(id));
  const selectAll = selected.length === shipmentIds.length;

  return {
    selected,
    expanded,
    selectAll,
  };
}

export default withTranslation()(ShipmentsList);
